import React, { useState } from "react";
import { Button, Modal, useWizard } from "@picklebet/ui";
import { useSkrillEmails } from "@/hooks/firestore/user/useSkrillDeposits";
import { OptionRow } from "@/features/wallet/components/deposit/components/deposit-wizard/option-row/OptionRow";
import { MethodRowSkeleton } from "@/features/wallet/components/deposit/components/deposit-wizard/method-row/MethodRow";
import { SkrillMethodIcon } from "@/features/wallet/components/deposit/components/deposit-wizard/method-row/SkrillMethodIcon";
import { useWithdrawWizard } from "@/features/wallet/components/withdraw/hooks/useWithdrawWizard";
import { WithdrawContent } from "../../blocks/withdraw-content/WithdrawContent";

import * as styles from "./SkrillEmailStep.module.scss";

export const SkrillEmailStep = () => {
  const { back } = useWizard();
  const { skrillEmail, setSkrillEmail } = useWithdrawWizard();
  const { emails, isLoading } = useSkrillEmails();

  const [pendingEmail, setPendingEmail] = useState<string>();
  const activeEmail = pendingEmail ?? skrillEmail ?? emails[0];

  const handleDone = () => {
    if (activeEmail) {
      setSkrillEmail(activeEmail);
    }

    back();
  };

  if (isLoading) {
    return (
      <WithdrawContent>
        <MethodRowSkeleton />
        <MethodRowSkeleton />
      </WithdrawContent>
    );
  }

  return (
    <WithdrawContent>
      <div
        className={styles.options}
        role="radiogroup"
        aria-label="Select Skrill account"
      >
        {emails.map((email) => (
          <OptionRow
            key={email}
            label={email}
            icon={<SkrillMethodIcon />}
            selected={email === activeEmail}
            onSelect={() => setPendingEmail(email)}
          />
        ))}
      </div>

      <p className={styles.explainer}>
        Withdrawals can only be sent to a Skrill account you have deposited
        from.
      </p>

      <Modal.Footer>
        <Button
          className={styles.doneButton}
          onClick={handleDone}
          disabled={!activeEmail}
        >
          Done
        </Button>
      </Modal.Footer>
    </WithdrawContent>
  );
};
